import React from "react";

export default function HowToReachRajgir() {
  return (
    <div className="travel-guide-container">
      {/* Card displaying the entire travel information */}
      <div className="travel-card">
        <h2 className="travel-title">How To Reach Rajgir</h2>

        <p className="card-description">
          <strong>
            Rajgir is an ancient city, originally known as Rajagriha, located
            about 15 km from Nalanda. It holds historical significance in
            Buddhism, Jainism, and ancient Indian history. Here’s how you can
            reach Rajgir through various modes of transportation:
          </strong>
        </p>

        <h3 className="section-title">1. Nearest Airport</h3>
        <ul className="card-list">
          <li style={{ listStyle: "auto" }}>
            <strong>Jay Prakash Narayan International Airport (Patna)</strong> –
            About 100 km from Rajgir.
            <ul>
              <li style={{ listStyle: "outside" }}>
                <em>From the Airport:</em> You can take a taxi or bus from Patna
                to Rajgir. It takes around 2.5 to 3 hours to reach Rajgir by
                road.
              </li>
            </ul>
          </li>
          <li style={{ listStyle: "auto" }}>
            <strong>Gaya International Airport (Gaya)</strong> – About 69 km
            from Rajgir.
            <ul>
              <li style={{ listStyle: "outside" }}>
                <em>From the Airport:</em> You can take a taxi or bus from Gaya
                to Rajgir. It takes around 1.5 to 2 hours by road.
              </li>
            </ul>
          </li>
        </ul>

        <h3 className="section-title">2. By Train</h3>
        <ul className="card-list">
          <li style={{ listStyle: "auto" }}>
            <strong>Rajgir Railway Station:</strong> Located within the town,
            connected to major cities like Patna, Gaya, and Nalanda.
          </li>
          <li style={{ listStyle: "auto" }}>
            <strong>Gaya Junction:</strong> About 78 km from Rajgir. It is
            well-connected to major Indian cities.
          </li>
          <li style={{ listStyle: "auto" }}>
            <strong>Patna Junction:</strong> About 100 km from Rajgir. It serves
            as a major railway hub with frequent trains to various parts of
            India.
          </li>
          <li style={{ listStyle: "auto" }}>
            <em>From Patna/Gaya:</em> You can take a local train or bus from
            these stations to Rajgir.
          </li>
        </ul>

        <h3 className="section-title">3. By Road</h3>
        <ul className="card-list">
          <li style={{ listStyle: "auto" }}>
            Rajgir is well-connected by road to major cities in Bihar and
            neighboring states.
          </li>
          <li style={{ listStyle: "auto" }}>
            <strong>From Patna:</strong> The distance is around 100 km. You can
            take a bus, taxi, or self-drive via the Patna-Bihar Sharif-Rajgir
            road, which takes about 2.5 to 3 hours.
          </li>
          <li style={{ listStyle: "auto" }}>
            <strong>From Gaya:</strong> The distance is around 78 km, and it
            takes about 2 hours by road.
          </li>
        </ul>

        <h3 className="section-title">4. By Bus</h3>
        <ul className="card-list">
          <li style={{ listStyle: "auto" }}>
            Regular buses run from Patna, Gaya, and Nalanda to Rajgir. The Bihar
            State Tourism Development Corporation (BSTDC) also offers bus
            services for tourists.
          </li>
          <li style={{ listStyle: "auto" }}>
            <strong>From Patna or Gaya:</strong> It takes approximately 2-3
            hours by bus.
          </li>
        </ul>

        <p className="conclusion-text">
          Choose the mode of transportation that suits you best and explore the
          historical charm of Rajgir.
        </p>
      </div>
    </div>
  );
}
